function transformUrlToName(url: string): string {
  if (url === '/') return 'home';

  return (url.split('/').pop() || url).replace(/[-]/g, ' ').replace('/', '');
}

export default transformUrlToName;
